import * as React from 'react';

const IconNavBack24 = (
  props: React.HTMLAttributes<SVGElement>
): JSX.Element => {
  return (
    <svg {...props} width="24" height="24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5303 3.53033c.2929-.29289.2929-.76777 0-1.06066s-.7677-.29289-1.0606 0L2.46967 11.4697c-.29289.2929-.29289.7677 0 1.0606l9.00003 9c.2929.2929.7677.2929 1.0606 0 .2929-.2929.2929-.7677 0-1.0606L4.81066 12.75H21c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75H4.81066l7.71964-7.71967z"
        fill="#202225"
      />
    </svg>
  );
};

export default IconNavBack24;
